'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { cn } from '../../utils/cn';
import { useUploadContext } from './UploadContext';
const UploadBody = forwardRef(({ children, className, ...props }, ref) => {
    const { options, horizontal } = useUploadContext();
    const { getRootProps, getInputProps } = useDropzone(options);
    return (_jsxs("div", { ...props, ref: ref, ...getRootProps(), className: cn(horizontal
            ? 'flex cursor-pointer items-center gap-4 rounded-xl border border-dashed bg-white px-3 transition-all duration-300 hover:bg-metal-25 dark:border-metal-800 dark:bg-metal-900 dark:hover:bg-metal-900'
            : 'flex cursor-pointer flex-col items-center rounded-xl border border-dashed border-metal-50 bg-white p-3 text-center transition-all duration-300 hover:bg-metal-25 dark:border-metal-800 dark:bg-metal-900 dark:hover:bg-metal-900', className), children: [_jsx("input", { ...getInputProps() }), children] }));
});
UploadBody.displayName = 'UploadBody';
export { UploadBody };
